export default __webpack_public_path__ + "static/bench-in-forrest-14013297a1a19b1c65a0055cde24be0b.jpg";